import React from 'react';

function Approved() {
	return <div>Approved</div>;
}

export default Approved;
